<ng-container #searchResults>

</ng-container>